import React from 'react'
import SkillBox from './SkillBox';

const ThisWebsite = () => {
    const items = [
        { name: "React.js", src: "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg" },
        { src: "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png", name: "JavaScript" },
        { name: "TailwindCSS", src: "https://upload.wikimedia.org/wikipedia/commons/d/d5/Tailwind_CSS_Logo.svg" },
        { name: "MaterialUI", src: "https://mui.com/static/logo.png" }
    ];
    return (
        <footer className="bg-gradient-to-br from-slate-800 via-slate-900 to-slate-800 flex flex-col items-center justify-center py-12 sm:py-16 px-4 sm:px-8 gap-6 sm:gap-8 border-t-2 border-slate-700">
            <div className="max-w-6xl mx-auto w-full">
                <h2 className="text-2xl sm:text-3xl font-bold text-white text-center mb-2">
                    Built With Modern Technologies
                </h2>
                <p className="text-slate-300 text-center mb-8 text-base sm:text-lg">
                    This website was crafted using:
                </p>

                <section className="flex flex-wrap justify-center gap-6 sm:gap-8 md:gap-10 mb-10">
                    {items.map((i, idx) => (
                        <div key={idx} className="transform transition-all duration-300 hover:scale-110">
                            <SkillBox name={i.name} src={i.src} size={96} />
                        </div>
                    ))}
                </section>

                <div className="border-t border-slate-700 pt-8 mt-8">
                    <p className="text-slate-400 text-center text-sm sm:text-base">
                        © {new Date().getFullYear()} Nicholas Gitman. All rights reserved.
                    </p>
                    <p className="text-slate-500 text-center text-xs sm:text-sm mt-2">
                        Designed and developed with passion ❤️
                    </p>
                </div>
            </div>
        </footer>
    )
}

export default ThisWebsite